class WindowUtils {
  static refresh(url) {
    window.location.hash = url || '';
    window.location.reload(true);
  }

  static navigate(url) {
    window.location = url;
  }

  static addToSessionStorage(key, value) {
    window.sessionStorage.setItem(key, value);
  }

  static getFromSessionStorage(key) {
    return window.sessionStorage.getItem(key);
  }

  static clearSessionStorage() {
    window.sessionStorage.clear();
  }

  static openInNewTab(url) {
    let win = window.open(url, '_blank');
    win.focus();
  }

  static screenWidth() {
    let viewportwidth;

    // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight

    if (typeof window.innerWidth != 'undefined') {
      viewportwidth = window.innerWidth;
    }

    // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
    else if (
      typeof document.documentElement != 'undefined' &&
      typeof document.documentElement.clientWidth != 'undefined' &&
      document.documentElement.clientWidth != 0
    ) {
      viewportwidth = document.documentElement.clientWidth;
    }

    // older versions of IE
    else {
      viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
    }

    return viewportwidth;
  }
}

export default WindowUtils;
